import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { languageResource } from './i18n/index';
import { getLocalStorage } from './utils/localStorage';

// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = languageResource;

const userBrowserLang = navigator.language === 'fr' ? 'fr' : 'en';
i18n.use(initReactI18next).init({
  resources,
  lng:
    getLocalStorage('LANGUAGE') === undefined 
      ? userBrowserLang
      : getLocalStorage('LANGUAGE'),

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
